import axios, { AxiosResponse, AxiosError } from 'axios'
// import * as Sentry from '@sentry/vue'


const {
  VUE_APP_AUTH_HEADER,
} = process.env
export const createAuthHeaderInterceptor = (data: { onAuthHeader: (hash: string) => void }) => (
  (response: AxiosResponse) => {
    const { onAuthHeader } = data
    const headers = response.headers as Record<string, string>

    const authHash = (
      headers[VUE_APP_AUTH_HEADER]
      || headers[VUE_APP_AUTH_HEADER.toLowerCase()]
    )

    // Защита от множественных запросов, если вдруг не окажется заголовка
    if (authHash) onAuthHeader(authHash)

    return response
  }
)

export const create401ErrorInterceptor = (data: { onUnauthorized: () => void }) => (
  (axiosError: AxiosError) => {
    const { onUnauthorized } = data

    const is401Error = [
      axiosError.response?.status,
      axiosError.code && +axiosError.code,
    ].includes(401)

    // @ts-ignore TODO:
    if (is401Error && axiosError?.config?.redirect401 !== false) {
      onUnauthorized()
    }

    return Promise.reject(axiosError)
  }
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createExtractInterceptor = <T = any>() => (
  response: AxiosResponse<T>,
) => response?.data ?? response

export const createExtractErrorInterceptor = () => (
  axiosError: AxiosError<Record<string, unknown>>,
) => {
  // Sentry exception handler
  // const scope = new Sentry.Scope()
  // scope.setTag('namespace', 'http')
  // if (axiosError.response) {
  //   scope.setExtra('request', axiosError.request)
  //   scope.setExtra('response', axiosError.response)
  // } else if (axiosError.request) {
  //   scope.setExtra('request', axiosError.request)
  // }
  // Sentry.captureException(axiosError, scope)

  if (axios.isCancel(axiosError)) {
    return Promise.reject(axiosError)
  }

  const data = axiosError.response?.data || {}
  let error = {
    ...axiosError,
    message: axiosError.response ? axiosError.message : 'Сервис недоступен',
    ...axiosError.response,
  }

  if (typeof data === 'string' /* html */) {
    if (process.env.NODE_ENV !== 'production') {
      error.message = data
      return Promise.reject(error)
    }
  } else {
    error = { ...error, ...data }
  }

  return Promise.reject(error)
}
